module.exports = __webpack_public_path__ + "img/image-01.1f548ec8.png";